import { Box, Typography } from "@mui/material";
import { BookText, FileCode, NotebookText } from "lucide-react";
import ItemCard from "pages/geoscape-hub/dashboard/hub-card";
import * as Routes from "routes";

export const DocsPage = () => {
  return <ActionMenu />;
};

const ActionMenu = () => {
  const actions = [
    {
      id: 1,
      title: "Data Docs",
      path: Routes.geoscapeDocumentation,
      icon: <BookText size={36} color="#1976D2" />,
      target: "_blank",
    },
    {
      id: 2,
      title: "Pre-Release Report",
      path: Routes.docsPreRelease,
      icon: <NotebookText size={36} color="#ED6C02" />,
      target: "_blank",
    },
    {
      id: 3,
      title: "API Docs",
      path: Routes.docsApi,
      icon: <FileCode size={36} color="#9C27B0" />,
      target: "_blank",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      <Typography
        // variant="h3"
        sx={{
          marginTop: "150px",
          fontSize: "48px",
          fontWeight: "700",
          textAlign: "center",
        }}
      >
        What are you learning today?
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "16px",
          justifyContent: "center",
          alignContent: "center",
          alignSelf: "stretch",
          flexWrap: "wrap",
        }}
      >
        {actions.map((item, id) => (
          <ItemCard item={item} id={id} />
        ))}
      </Box>
    </Box>
  );
};
